import { CiCircleChevLeft } from "react-icons/ci";

import { Images } from "../../config";
import { popover, Loader } from "../../components";
import { ProfileDropDown } from "../../components/layouts/profile-dropdown";
import { Link } from "react-router-dom";

const VisionAINavbar = ({ profileData, aiDocs, isDocsLoading }) => {
  return (
    <div className="fixed z-[100] w-full px-[1.5em] py-[1em] flex justify-between items-center bg-white/10 backdrop-blur-md supports-[backdrop-filter]:bg-white/10 border-b ">
      <div className="flex items-center gap-2 ml-[18.75em]">
        <CiCircleChevLeft
          className="navbar-back-icon"
          onClick={() => window.history.back()}
        />
        <div className="navbar-title !text-[1.4em]">VisionAI</div>
      </div>
      <div className="flex gap-3">
        <popover.WhitePopover
          content={
            <div className="flex flex-col gap-3 justify-center items-center w-[25em]">
              <div className="font-semibold text-[1.2em]">Browse Documents</div>
              {aiDocs?.map((item, index) => (
                <Link
                  to={item?.url}
                  className="w-full p-1 rounded-lg hover:bg-main hover:!text-white flex gap-2"
                  target="_blank"
                  title={item?.name}
                  key={index}
                >
                  <div className="rounded-full w-[3em] h-[3em] flex justify-center items-center border border-[#D4D4D4] shadow-visionAiNavShadow bg-visionAiNavBtn-gradient cursor-pointer">
                    <img
                      src={Images.VisionAINav3}
                      className="w-[1.5em] h-[1.5em]"
                    />
                  </div>
                  <span className="w-[85%]">{item?.name}</span>
                </Link>
              ))}
            </div>
          }
          placement={"top"}
          trigger="click"
        >
          <div className="rounded-full w-[3em] h-[3em] object-cover flex justify-center items-center border border-[#D4D4D4] shadow-visionAiNavShadow bg-visionAiNavBtn-gradient cursor-pointer">
            {isDocsLoading ? (
              <Loader.ButtonLoader />
            ) : (
              <img src={Images.VisionAINav3} className="w-[1.5em] h-[1.5em]" />
            )}
          </div>
        </popover.WhitePopover>

        <ProfileDropDown profileData={profileData} />
        <div className="navbar-name-container">
          <div className="navbar-name">
            {profileData?.firstName} {profileData?.lastName}
          </div>
          <div className="navbar-email">{profileData?.email}</div>
        </div>
      </div>
    </div>
  );
};

export default VisionAINavbar;
